import "./profile.scss"
import "./edit.scss"
import "./subscription.scss"
import "./components/profile-card.scss"
import "./components/profile-tabs.scss"
import "./components/tabs/my-locations.scss"
import "./components/tabs/photos.scss"
import "./static/icon-edit.svg"
import "./static/icon-user.svg"
import "./static/icon-caret-right.svg"
import "./static/icon-arrow-up.svg"
import "./static/icon-arrow-left.svg"
import "./static/icon-heart-fill.svg"

import { BaseComponent, BElement } from "utils/base-component"

export class TabNavigationComponent extends BaseComponent {
  static cssClass = "profile-tabs"
  private tabs!: BElement[]
  private contentSection!: BElement[]

  init(): void {
    this.tabs = this.elements("tab")
    this.contentSection = this.elements("content-section")

    this.setupTabListeners()
  }

  private setupTabListeners(): void {
    // Store references to avoid 'this' context issues in event listeners
    const tabsRef = this.tabs
    const contentSectionRef = this.contentSection

    // Initialize the first tab as active and hide other sections
    TabNavigationComponent.initializeFirstTab(tabsRef, contentSectionRef)

    this.tabs.forEach((tab) => {
      tab.element.addEventListener("click", () => {
        TabNavigationComponent.handleTabClick(tab, tabsRef, contentSectionRef)
      })
    })
  }

  private static handleTabClick(
    clickedTab: BElement,
    tabs: BElement[],
    contentSection: BElement[],
  ): void {
    const clickedTabIndex = tabs.indexOf(clickedTab)

    if (clickedTabIndex === -1) {
      // eslint-disable-next-line no-console
      console.warn("Clicked tab not found in tabs array")
      return
    }

    TabNavigationComponent.updateTabStates(tabs, clickedTabIndex)
    TabNavigationComponent.updateContentStates(contentSection, clickedTabIndex)
  }

  private static updateTabStates(tabs: BElement[], activeIndex: number): void {
    tabs.forEach((tab, index) => {
      tab.toggleModifier("is-active", index === activeIndex)
    })
  }

  private static updateContentStates(contentSection: BElement[], activeIndex: number): void {
    contentSection.forEach((section, index) => {
      section.toggleModifier("is-hidden", index !== activeIndex)
      section.toggleModifier("is-active", index === activeIndex)
    })
  }

  private static initializeFirstTab(tabs: BElement[], contentSection: BElement[]): void {
    // Set first tab as active
    tabs[0].toggleModifier("is-active")

    // Hide all content sections except the first one
    contentSection.forEach((section, index) => {
      if (index === 0) {
        section.toggleModifier("is-active")
      } else {
        section.toggleModifier("is-hidden")
      }
    })
  }
}
